import { setupApp } from '@/common/setup-app/setup-app.js'

import '../configuration/spark'
import '../configuration/axios'
import '../configuration/luxon'
import '../configuration/form'

import '../../css/embed-form.css'

setupApp()
